import Zone from "@insite/client-framework/Components/Zone";
import logger from "@insite/client-framework/Logger";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getCurrentUserIsGuest } from "@insite/client-framework/Store/Context/ContextSelectors";
import { getCurrentPage, getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import { getPageLinkByPageType } from "@insite/client-framework/Store/Links/LinksSelectors";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Page from "@insite/mobius/Page";
import { HasHistory, withHistory } from "@insite/mobius/utilities/HistoryContext";
import React from "react";
import { connect } from "react-redux";

const mapStateToProps = (state: ApplicationState) => ({
    isSignInPage: getCurrentPage(state).type === "SignInPage",
    userName: state.context.session.userName,
    currentUserIsGuest: getCurrentUserIsGuest(state),
    signInUrl: getPageLinkByPageType(state, "SignInPage")?.url,
    currentLocation: getLocation(state),
    userRole: state.context.session.userRoles,
    isSuryaInternalUser: state.context.session.properties?.isSuryaInternalUser,
});

type Props = WidgetProps & ReturnType<typeof mapStateToProps> & HasHistory;

const SurIsAuthenticated = ({
    id,
    isSignInPage,
    history,
    userRole,
    isSuryaInternalUser
}: Props) => {
    React.useEffect(() => {
        if ((userRole !== "Administrator" && userRole !== "Buyer3") && !isSignInPage) {
            history.push("/");
        }
    });
    return (
        <Page>
            <Zone contentId={id} zoneName="Content" />
        </Page>
    );
};
const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, null)(withHistory(SurIsAuthenticated)),
    definition: {
        group: "Basic",
        icon: "LogIn",
        displayName: "SurIsAuthenticated",
    },
};
export default widgetModule;
